import { render, staticRenderFns } from "./drygoods.vue?vue&type=template&id=5ef1951e&"
import script from "./drygoods.vue?vue&type=script&lang=js&"
export * from "./drygoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports